"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const lang_1 = require("../../lang");
const link_1 = require("../../utils/link");
const index_vue_1 = tslib_1.__importDefault(require("../Modal/index.vue"));
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
    const $t = (0, lang_1.useI18n)();
    const text = (0, vue_demi_1.computed)(() => {
        return $t('modal.actEnd');
    });
    return {
        toActCenter: link_1.toActCenter,
        text
    };
};
__sfc_main.components = Object.assign({
    Modal: index_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXgudnVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaW5kZXgudnVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVdBLHVDQUFvQztBQUNwQyxxQ0FBcUM7QUFDckMsMkNBQStDO0FBQy9DLDJFQUF1QztBQUN2QyxNQUFNLFVBQVUsR0FBRyxFQUFFLENBQUM7QUFDdEIsVUFBVSxDQUFDLEtBQUssR0FBRyxDQUFDLE9BQU8sRUFBRSxLQUFLLEVBQUUsRUFBRTtJQUNwQyxNQUFNLEVBQUUsR0FBRyxJQUFBLGNBQU8sR0FBRSxDQUFDO0lBQ3JCLE1BQU0sSUFBSSxHQUFHLElBQUEsbUJBQVEsRUFBQyxHQUFHLEVBQUU7UUFDekIsT0FBTyxFQUFFLENBQUMsY0FBYyxDQUFDLENBQUM7SUFDNUIsQ0FBQyxDQUFDLENBQUM7SUFDSCxPQUFPO1FBQ0wsV0FBVyxFQUFYLGtCQUFXO1FBQ1gsSUFBSTtLQUNMLENBQUM7QUFDSixDQUFDLENBQUM7QUFDRixVQUFVLENBQUMsVUFBVSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUM7SUFDcEMsS0FBSyxFQUFMLG1CQUFLO0NBQ04sRUFBRSxVQUFVLENBQUMsVUFBVSxDQUFDLENBQUM7QUFDMUIsa0JBQWUsVUFBVSxDQUFDIn0=